import RetailerList from './components/RetailerList';
import { bindActionCreators } from 'redux';
import withRouter from 'react-router-dom/withRouter'
import values from 'lodash/values';
import get from 'lodash/get';
import { connect } from 'react-redux';

import {
  loadRetailers,
  loadAgencies,
  loadBrands
} from '../../shared/redux/entities/actions'

function mapStateToProps(state,props){
  const retailers = values(state.entities.companies)
    .filter((b) => b.name && b.name.length > 0 && !b.isBrand)
    .sort((a,b) => (a.name || '').localeCompare((b.name || '')))
    .map((r) => {
      r.approvedBrands = (r.approvedBrandIds || [])
        .sort()
        .map((id) => ({
          id:id,
          name:get(state,['entities','companies',id,'name'],'').trim()
        }))

      return r;
    })

  const brands = values(state.entities.companies)
    .filter((b) => b.name && b.name.length > 0 && b.isBrand)
    .sort((a,b) => (a.name || '').localeCompare((b.name || '')))


  return {
    retailers:retailers,
    brands:brands,
    agencies:values(get(state,['entities','agencies'],{}))
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    loadRetailers,
    loadAgencies,
    loadBrands
  },dispatch);
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(RetailerList));



// WEBPACK FOOTER //
// ./src/routes/RetailerList/index.js